import React, {useState} from 'react';
import {Box, Button, Grid, IconButton, TextField, Typography} from "@mui/material";
import Divider from '@mui/material/Divider';
import {PostNewTicketApi} from "../../../api/ClientApi";
import FaNum from "../../../components/Site/faNum/FaNum";
import {errorMessage, successMessage} from "../../../tools/messages";
import {GetState} from "../../../redux/reduxhelper";
import {IS_AUTH} from "../../../redux/action/type.action";
import {useNavigate} from "react-router";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import {fixStringToTextView} from "../../../tools/helper";

const ContactUs = () => {
    const isAuth = GetState(IS_AUTH, false)
    const navigate = useNavigate();
    const defData = {
        fullname: "",
        mobile: "",
        company_name: "",
        body: ""
    }
    const [ticketData, setTicketData] = useState(defData)

    const NewTicket = async () => {
        try {
            let res = await PostNewTicketApi(ticketData)
            console.log(res?.data);
            successMessage('با موفقیت انجام شد')
            setTicketData(defData)
        } catch (e) {
            errorMessage('خطا در انجام عملیات')
        }
    }

    return (
        <Grid container sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            padding: '5% 10% 10% 10%'
        }}>
            <Box sx={{
                flexDirection: 'column',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                padding: '8px 32px 32px 32px',
                textAlign: "center"
            }}>

                <Typography variant={'h3'} sx={{
                    color: '#232536', fontWeight: 700

                }}>
                    با ما در اتباط باشید
                </Typography>


                <Typography variant={'subtitle2'} sx={{
                    color: '#6D6E76',
                    marginBottom: 3,
                    marginTop: 2
                }}>
                    ما پاسخگوی سوال ها و نیازهای شما هستیم تا بهترین خدمات را به شما ارایه دهیم.
                </Typography>
                {isAuth && <Box sx={{textAlign: "right",width: '100%'}}>
                    <IconButton  sx={{color: "#592EA9", cursor: "pointer"}}
                                 onClick={() => navigate('/admin/dashboard/tickets')}>
                        <EditOutlinedIcon/>
                    </IconButton>
                </Box>}
                <Box sx={{
                    marginY: 2,
                    background: '#592EA9',
                    width: '100%'
                }}>

                    <Grid padding={2} sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: 'center',
                        gap: 1
                    }}>

                        <Typography
                            sx={{color: '#FFFFFF', opacity: 0.6}}>
                            ساعات کاری
                        </Typography>
                        <Divider
                            variant={'fullWidth'}
                            sx={{borderColor: '#fff'}}
                        />
                        <Typography sx={{
                            color: '#fff', fontFamily: 'Sen',
                        }}>
                            شنبه تا چهارشنبه
                            <br/>
                            {<FaNum>9</FaNum>} صبح الی {<FaNum>17</FaNum>}
                            <br/>
                        </Typography>

                        <Typography sx={{color: '#FFFFFF', opacity: 0.6, textAlign: "center"}}>
                            تیم پشتیبانی در کوتاه ترین زمان پاسخگوی شما می باشد.
                        </Typography>
                    </Grid>

                </Box>

                <Grid sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 1,
                    width: '100%'
                }}>
                    <TextField
                        value={fixStringToTextView(ticketData?.fullname)}
                        onChange={(e) => setTicketData({...ticketData, fullname: e.target.value})}
                        id="filled-size-normal"
                        label="نام و نام خانوادگی"
                        variant="outlined"
                    />
                    <TextField
                        value={ticketData?.mobile}
                        onChange={(e) => setTicketData({...ticketData, mobile: e.target.value})}
                        multiline={true}
                        id="outlined-multiline-flexible"
                        label="تلفن همراه"
                    />
                    <TextField
                        value={fixStringToTextView(ticketData?.company_name)}
                        onChange={(e) => setTicketData({...ticketData, company_name: e.target.value})}
                        id="filled-size-normal"
                        label="نام شرکت"
                        variant="outlined"
                    />
                    <TextField
                        value={fixStringToTextView(ticketData?.body)}
                        onChange={(e) => setTicketData({...ticketData, body: e.target.value})}
                        multiline={true}
                        id="outlined-multiline-flexible"
                        label="پیام"
                        inputProps={{sx: {minHeight: 150}}}
                    />

                    <Button variant={'outlined'} sx={{
                        background: '#FFD050',
                        transition: 'all .5s',
                        color: '#232536',
                        '&:hover': {bgcolor: '#c49517', color: '#ffffff'}
                    }} onClick={NewTicket}> ارسال پیام</Button>
                </Grid>
            </Box>
        </Grid>
    );
};

export default ContactUs;